import React, { useState } from 'react';
import { Button, Modal, Table } from 'antd';
import { currency } from '../../quotationProduct/formatNumber';

const RenderItem = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const columns = [
    {
      title: '费用项',
      dataIndex: 'key',
      key: 'key',
      render: (text) => <a>{text}</a>,
    },
    {
      title: '费用金额（元）',
      dataIndex: 'value',
      key: 'value',
      render: (text) => <a>¥{currency(+text)}</a>,
    },
    {
      title: '费用备注',
      dataIndex: 'cost_explain',
      key: 'cost_explain',
      render: (text) => <a>{text}</a>,
    },
  ];
  const dataSource = (props?.item?.other_cost || []).map(item => ({ ...item, label: item.value }));
  return (
    <>
      <Button type="link" onClick={showModal}>{props?.btn_title || ''}明细{isModalOpen}</Button>
      <Modal title={<>{props?.title || ''}费用明细</>} open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={null}>
        <Table columns={columns} dataSource={dataSource} rowKey='key' pagination={false} />
      </Modal>
    </>
  );
};
export default RenderItem;